import React, { useEffect, useState } from 'react';
import { billingAPI } from '../api/client';
import { Badge, Button } from '../components/ui';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const GATEWAY_META = {
  stripe:      { label: 'Stripe',       icon: '💳', desc: 'Tarjeta de crédito/débito' },
  paypal:      { label: 'PayPal',       icon: '🅿️', desc: 'Cuenta PayPal' },
  mercadopago: { label: 'MercadoPago',  icon: '🟦', desc: 'PSE, Nequi, tarjetas LATAM' },
  wompi:       { label: 'Wompi',        icon: '🇨🇴', desc: 'Colombia — PSE, Nequi, Bancolombia' },
};
const PLAN_COLOR = { free: '#6b7280', starter: '#3b82f6', pro: '#7c3aed', agency: '#f59e0b' };
const PLAN_ICON  = { free: '🆓', starter: '🚀', pro: '⚡', agency: '🏢' };

function CheckoutModal({ plan, cycle, gateways, onClose }) {
  const [selectedGateway, setSelectedGateway] = useState(gateways[0]?.name || '');
  const [loading, setLoading] = useState(false);
  const [checkoutUrl, setCheckoutUrl] = useState(null);
  const [success, setSuccess] = useState(false);
  const color = PLAN_COLOR[plan.slug] || '#7c3aed';
  const price = cycle === 'yearly' ? plan.price_yearly : plan.price_monthly;

  useEffect(() => {
    const handler = async (e) => {
      if (e.data?.type === 'payment-complete') {
        setCheckoutUrl(null);
        setSuccess(true);
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  const handlePay = async () => {
    console.log('handlePay called, gateway:', selectedGateway, 'plan:', plan.id);
    if (!selectedGateway) { toast.error('Selecciona una forma de pago'); return; }
    setLoading(true);
    try {
      const { data } = await billingAPI.checkout({ plan_id: plan.id, billing_cycle: cycle, gateway: selectedGateway });
      if (data.checkout_url) {
        setCheckoutUrl(data.checkout_url);
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Error al procesar el pago');
      setLoading(false);
    }
  };

  if (success) return (
    <div style={{ position:'fixed', inset:0, zIndex:1000, background:'rgba(0,0,0,0.75)', backdropFilter:'blur(4px)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' }}>
      <div style={{ background:'var(--bg-card)', borderRadius:'24px', width:'100%', maxWidth:'400px', border:`1px solid ${color}40`, padding:'40px 32px', textAlign:'center' }}>
        <div style={{ fontSize:60, marginBottom:12 }}>🎉</div>
        <div style={{ fontFamily:'var(--font-display)', fontWeight:800, fontSize:20, color, marginBottom:8 }}>¡Suscripción activada!</div>
        <div style={{ fontSize:14, color:'var(--text-muted)', marginBottom:20, lineHeight:1.7 }}>
          Tu plan <strong>{plan.name}</strong> está activo.<br/>¡Disfruta todos los beneficios!
        </div>
        <button onClick={() => window.location.href = '/'} style={{ background:color, color:'#fff', border:'none', borderRadius:12, padding:'12px 32px', fontWeight:700, fontSize:15, cursor:'pointer', width:'100%' }}>
          Continuar →
        </button>
      </div>
    </div>
  );

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
    }} onClick={onClose}>
      <div style={{
        background: 'var(--bg-card)', borderRadius: '24px', width: '100%', maxWidth: '440px',
        border: `1px solid ${color}40`, boxShadow: `0 24px 80px rgba(0,0,0,0.6), 0 0 40px ${color}20`,
        overflow: 'hidden',
      }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ padding: '24px 24px 20px', borderBottom: '1px solid var(--border)', background: `${color}10` }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '28px' }}>{PLAN_ICON[plan.slug]}</span>
              <div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: '800', fontSize: '18px', color }}>Plan {plan.name}</div>
                <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{cycle === 'yearly' ? 'Facturación anual' : 'Facturación mensual'}</div>
              </div>
            </div>
            <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '20px', lineHeight: 1 }}>✕</button>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
            <span style={{ fontFamily: 'var(--font-display)', fontSize: '36px', fontWeight: '800', color }}>${price}</span>
            <span style={{ color: 'var(--text-muted)', fontSize: '14px' }}>/{cycle === 'yearly' ? 'año' : 'mes'}</span>
          </div>
          {cycle === 'yearly' && price > 0 && (
            <div style={{ fontSize: '12px', color: '#10b981', fontWeight: '600', marginTop: '4px' }}>
              ≈ ${Math.round(price / 12)}/mes · Ahorras ${Math.round(plan.price_monthly * 12 - price)}
            </div>
          )}
        </div>

        {/* Iframe o selector de pasarela */}
        <div style={{ padding: '20px 24px' }}>
          {checkoutUrl ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <iframe
                src={checkoutUrl}
                title="Checkout"
                style={{ width: '100%', height: '600px', border: 'none', borderRadius: '12px', background: '#fff' }}
              />
              <button onClick={() => setCheckoutUrl(null)} style={{ display:'none' }}>
              </button>
            </div>
          ) : (
            <>
              <p style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', marginBottom: '12px' }}>💳 Selecciona tu forma de pago</p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
                {gateways.map(gw => {
                  const meta = GATEWAY_META[gw.name] || { label: gw.name, icon: '💳', desc: '' };
                  const sel = selectedGateway === gw.name;
                  return (
                    <div key={gw.name} onClick={() => setSelectedGateway(gw.name)} style={{
                      display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px',
                      borderRadius: '12px', cursor: 'pointer', transition: 'all 0.15s',
                      border: `1px solid ${sel ? color : 'var(--border)'}`,
                      background: sel ? `${color}15` : 'var(--bg-elevated)',
                    }}>
                      <span style={{ fontSize: '22px' }}>{meta.icon}</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '700', fontSize: '14px' }}>{meta.label}</div>
                        <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>{meta.desc}</div>
                      </div>
                      <div style={{
                        width: '20px', height: '20px', borderRadius: '50%',
                        border: `2px solid ${sel ? color : 'var(--border)'}`,
                        background: sel ? color : 'transparent',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#fff', fontSize: '11px', flexShrink: 0,
                      }}>{sel ? '✓' : ''}</div>
                    </div>
                  );
                })}
              </div>
              <button
                onClick={handlePay}
                disabled={loading || !selectedGateway}
                style={{
                  width: '100%', padding: '14px', borderRadius: '12px', border: 'none',
                  background: `linear-gradient(135deg, ${color}, ${color}cc)`,
                  color: '#fff', fontFamily: 'var(--font-body)', fontSize: '15px',
                  fontWeight: '700', cursor: loading ? 'wait' : 'pointer',
                  opacity: loading ? 0.7 : 1, transition: 'opacity 0.2s',
                }}
              >
                {loading ? '⟳ Procesando...' : `Continuar con ${GATEWAY_META[selectedGateway]?.label || selectedGateway} →`}
              </button>
              <p style={{ fontSize: '11px', color: 'var(--text-muted)', textAlign: 'center', marginTop: '10px' }}>
                🔒 Pago seguro · Cancela cuando quieras · Sin cargos ocultos
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default function PricingPage() {
  const { user } = useAuth();
  const [plans, setPlans]           = useState([]);
  const [gateways, setGateways]     = useState([]);
  const [subscription, setSubscription] = useState(null);
  const [cycle, setCycle]           = useState('monthly');
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading]       = useState(true);

  useEffect(() => {
    Promise.all([
      billingAPI.listPlans(),
      user ? billingAPI.getSubscription() : Promise.resolve({ data: null }),
    ]).then(([p, s]) => {
      setPlans(p.data);
      setSubscription(s.data);
      if (user) billingAPI.listGateways().then(r => {
        setGateways(r.data.filter(g => g.is_active));
      }).catch(() => {});
    }).finally(() => setLoading(false));
  }, [user]);

  const isCurrentPlan = (plan) => subscription?.plan?.slug === plan.slug;
  const getPrice = (plan) => cycle === 'yearly' ? plan.price_yearly : plan.price_monthly;

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px' }}>
      <div style={{ fontSize: '14px', color: 'var(--text-muted)' }}>Cargando planes...</div>
    </div>
  );

  return (
    <div style={{ padding: '40px 20px', maxWidth: '1100px', margin: '0 auto' }}>

      {/* Modal checkout */}
      {selectedPlan && (
        <CheckoutModal
          plan={selectedPlan}
          cycle={cycle}
          gateways={gateways}
          onClose={() => setSelectedPlan(null)}
        />
      )}

      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '32px', fontWeight: '800', marginBottom: '10px' }}>
          Planes y precios
        </h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '15px', maxWidth: '480px', margin: '0 auto 24px' }}>
          Publica más rápido con IA. Sin contratos, cancela cuando quieras.
        </p>
        <div style={{ display: 'inline-flex', background: 'var(--bg-elevated)', border: '1px solid var(--border)', borderRadius: '12px', padding: '4px', gap: '4px' }}>
          {[{ id: 'monthly', label: 'Mensual' }, { id: 'yearly', label: 'Anual · 20% off' }].map(o => (
            <button key={o.id} onClick={() => setCycle(o.id)} style={{
              padding: '8px 20px', borderRadius: '9px', border: 'none', cursor: 'pointer',
              background: cycle === o.id ? 'var(--gradient-primary)' : 'transparent',
              color: cycle === o.id ? '#fff' : 'var(--text-muted)',
              fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: cycle === o.id ? '700' : '500',
            }}>{o.label}</button>
          ))}
        </div>
      </div>

      {/* Planes */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', marginBottom: '48px' }}>
        {plans.map(plan => {
          const price = getPrice(plan);
          const color = PLAN_COLOR[plan.slug] || '#7c3aed';
          const isCurrent = isCurrentPlan(plan);
          const isPro = plan.slug === 'pro';

          return (
            <div key={plan.id} style={{
              background: 'var(--bg-card)', border: `2px solid ${isCurrent ? color : isPro ? color : 'var(--border)'}`,
              borderRadius: '20px', padding: '28px', position: 'relative',
              boxShadow: isPro ? `0 0 40px ${color}30` : 'none',
              transform: isPro ? 'scale(1.02)' : 'none',
            }}>
              {isPro && !isCurrent && (
                <div style={{ position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)', background: 'var(--gradient-primary)', color: '#fff', padding: '4px 16px', borderRadius: '99px', fontSize: '12px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                  ⭐ Más popular
                </div>
              )}
              {isCurrent && (
                <div style={{ position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)', background: color, color: '#fff', padding: '4px 16px', borderRadius: '99px', fontSize: '12px', fontWeight: '800', whiteSpace: 'nowrap' }}>
                  ✓ Plan actual
                </div>
              )}
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>{PLAN_ICON[plan.slug] || '📦'}</div>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: '800', marginBottom: '4px', color }}>{plan.name}</h2>
              <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginBottom: '20px', minHeight: '36px' }}>{plan.description}</p>
              <div style={{ marginBottom: '20px' }}>
                {plan.discount_percent > 0 && price > 0 && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '2px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '14px', color: 'var(--text-muted)', textDecoration: 'line-through' }}>
                      ${(cycle === 'yearly' ? (plan.regular_price_yearly ?? plan.price_yearly) : (plan.regular_price_monthly ?? plan.price_monthly)).toLocaleString('es-CO')}
                    </span>
                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#fff', background: '#ef4444', padding: '2px 8px', borderRadius: '99px', whiteSpace: 'nowrap' }}>
                      -{plan.discount_percent}%
                    </span>
                  </div>
                )}
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', flexWrap: 'wrap' }}>
                  <span style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(22px, 5vw, 28px)', fontWeight: '800', wordBreak: 'break-word' }}>
                    ${price === 0 ? '0' : price.toLocaleString('es-CO')}
                  </span>
                  {price > 0 && <span style={{ color: 'var(--text-muted)', fontSize: '13px', whiteSpace: 'nowrap' }}>/{cycle === 'yearly' ? 'año' : 'mes'}</span>}
                </div>
                {cycle === 'yearly' && price > 0 && (
                  <div style={{ fontSize: '12px', color: '#10b981', fontWeight: '600', marginTop: '4px' }}>
                    ≈ ${Math.round(price / 12).toLocaleString('es-CO')}/mes · Ahorras ${Math.round(plan.price_monthly * 12 - price).toLocaleString('es-CO')}
                  </div>
                )}
              </div>
{/* Tokens IA — solo uso interno */}
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 24px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {(plan.features || []).map((f, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: 'var(--text-secondary)' }}>
                    <span style={{ color, flexShrink: 0 }}>✓</span> {f}
                  </li>
                ))}
              </ul>
              {plan.slug === 'free' ? (
                isCurrent ? (
                  <div style={{ textAlign: 'center', padding: '10px', fontSize: '13px', color: 'var(--text-muted)', background: 'var(--bg-elevated)', borderRadius: '10px' }}>
                    Plan actual
                  </div>
                ) : (
                  <Button variant="ghost" style={{ width: '100%' }} onClick={() => window.location.href = user ? '/' : '/login'}>
                    {user ? 'Ir al dashboard' : 'Empezar gratis'}
                  </Button>
                )
              ) : (
                <Button
                  disabled={isCurrent}
                  style={{ width: '100%', background: isCurrent ? 'var(--bg-elevated)' : `linear-gradient(135deg, ${color}, ${color}cc)`, border: 'none' }}
                  onClick={() => { if (!user) { window.location.href = '/login'; return; } setSelectedPlan(plan); }}
                >
                  {isCurrent ? 'Plan actual' : `Elegir ${plan.name}`}
                </Button>
              )}
            </div>
          );
        })}
      </div>

      {/* FAQ */}
      <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
        <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: '700', fontSize: '20px', marginBottom: '24px' }}>Preguntas frecuentes</h3>
        {[
          { q: '¿Qué pasa si se acaban los tokens IA?', a: 'Puedes seguir publicando en modo manual — los tokens solo controlan la generación automática de captions con IA.' },
          { q: '¿Los tokens no usados se pierden?', a: 'No. El 20% del crédito no usado se transfiere al siguiente mes como rollover.' },
          { q: '¿Puedo cancelar en cualquier momento?', a: 'Sí. Sin penalidades. Tu plan sigue activo hasta el final del período pagado.' },
          { q: '¿Qué monedas aceptan?', a: 'USD globalmente. Con Wompi y MercadoPago también puedes pagar en COP, MXN, ARS, CLP y más.' },
        ].map((f, i) => (
          <div key={i} style={{ padding: '16px', background: 'var(--bg-elevated)', borderRadius: '12px', marginBottom: '10px', textAlign: 'left', border: '1px solid var(--border)' }}>
            <div style={{ fontWeight: '700', fontSize: '14px', marginBottom: '6px' }}>{f.q}</div>
            <div style={{ color: 'var(--text-muted)', fontSize: '13px', lineHeight: 1.6 }}>{f.a}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
